const translations = {
  "login.Title": "Login",
  "login.Username": "User name",
  "login.Password": "Password",
  "login.UserNotFound": "User / password is incorrect!",
  "login.Login": "Enter",
  "login.RememberMe": "Remember",
  "login.ForgotPassword": "Forgot the password?",
  USER_PASS_INCORRECT: "User / password is incorrect!",
  "new-password": "New password",
  "repeat-new-password": "Repeat the new password",
  getSMScode: "Receive SMS code",
  next: "Next",
  "login.PasswordIsIncorrect": "Password is Incorrect",
  smsAuth: "SMS authorization",
  auth: "Authorization",
  registration: "Registration",
  "recover-pass": "Recover the password",
  // "cant-find-policy": "Unfortunately, by the specified personal number no active policy can be found",
  "cant-find-policy": "To access the updated portal, please register",
  "auth-regis-code": "Authorization/registration by code",
  "passwrod-auth": "Authorization by password",
  "passwrod-validate":
    "Your new password must be at least 8 characters and include at least one number",
  "passwrod-has-space": "Password must not contain space",
  "passwrod-dont-match": "Passwords don’t match",
  "passwrod-matches-old": "Old and new password should not be same",
  next: "Next",
  next: "Next",
  "login.instrucation": "Instruction",
  "login.personalInfo": "Personal information",
  "login.lessthen18_1":
    "Since you are under age, your number should be changed by the policy holder",
  "login.lessthen18_2": "Your policy holder",
  "login.lessthen18_3":
    "should go through an identification process by means of Identomat",
  "login.insurerPid": "Policy holder's personal number",
  "login.approveTitle": "Permission to remote identification",
  "login.approve.parag_1":
    "Consent to identification/perdsonal data processing:",
  "login.approve_parag_2":
    "I give permission to JSC Insurance Company Imedi L and its authorized representative Raizomat LLC  (identification number: 402102005, registered address: Georgia, Tbilisi, Chugureti District, # 86/90 David Aghmashenebeli Avenue), for the purpose of remote identification, to receive and process my biometric data (for which it can take a photo and/or capture a live image of my face) and/or other documents used for my personal identification.",
  "login.approve_parag_3":
    "The received data may be processed outside the borders of Georgia on a secure server in Germany, in encrypted form, without access to the data content. I understand that my biometric data will be processed for providing the services, in compliance with the requirements of the applicable laws, in the scope and to the extent necessary to provide the services. My data received for remote identification will be stored for 5 years from the date of remote identification.",
  "login.approve_parag_4":
    "Besides, I am informed that am entitled to request access to my data, as well as to correct, delete the above-mentioned data, to restrict processing thereof, as well as to withdraw permission and to express refusal of the processing. I hereby declare and confirm that all my personal data, which I provide for the purpose of my remote identification, are correct and accurate. I declare that by carrying out remote identification I agree to the rules and conditions posted on the authorized representative’s",
  "login.approve.parag_5": "webpage.",
  "login.approve.parag3454":
    "**In case of failing the identification twice in a row you will be restricted from using the Identomat for two hours. Please follow the instructions and make sure that the quality of the photos is acceptable and the data available on them are readable, before confirming them.",
  "login.validat-title": "You have successfully passed the Identomat process!",
  "login.validat-paag":
    "Please go through an identification process by a new phone number",
  mobileNum: "phone number",
  "vali-title": "You have failed the Identomat process!",
  "validat-again": "Please try again",
  "login.persInfo": "Personal information",
  "login.remoteAgreement": "Permission to remote identification",
  "login.remoteAgreementIdentomat":
    "Remote identification with the help of Identomat",

  MinLength: "Password must be at least 8 characters.",
  "MissingA-Z": "Password must contain at least one uppercase letter (A–Z).",
  "Missinga-z": "Password must contain at least one lowercase letter (a–z).",
  "Missing0-9": "Password must contain at least one digit (0–9).",
  MissingSpecSymbols:
    "The password must contain at least one special character, such as: ! @ # $ % ^ & *.",
  OnlyLatin: "The password must contain only Latin letters",
};

export default translations;
